import { Card, styled } from "@mui/material";

export const StyledCard = styled(Card)(({ theme: { palette } }) => ({
  height: "100%",
  background: palette.main[50],
  border: `4px solid ${palette.common.white}`,
  boxShadow: `0 0 0 2px ${palette.primary.main}`,
  display: "flex",
  flexDirection: "column",
  overflow: "hidden",
}));

export const ServiceImage = styled("img")(() => ({
  width: "100%",
  height: "200px",
  objectFit: "cover",
}));

export const CardContent = styled("div")(({ theme: { spacing } }) => ({
  padding: spacing(3),
  flexGrow: 1,
  display: "flex",
  flexDirection: "column",
}));
